module.exports = __webpack_public_path__ + "static/media/Hohe-qualitaet1-small.3f22a1e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hohe-qualitaet1-small.jpg
// module id = 230
// module chunks = 8